import { Box, TextArea } from "@radix-ui/themes";
import { Control, Controller, FieldErrors } from "react-hook-form";
import {
  ComposedName,
  FieldShell,
  fieldAria,
  fieldIds,
  resolveFieldError,
} from "../FieldShell";

interface TextFieldProps {
  name: string;
  label: string;
  control: Control<any>;
  errors: FieldErrors<any>;
  style?: any;
  fieldProps?: any;
  composedName?: ComposedName;
  value?: string;
  required?: boolean;
  hint?: string;
}

const TextAreaFieldComponent = ({
  name,
  label,
  control,
  errors,
  style,
  fieldProps,
  composedName,
  value,
  required,
  hint,
}: TextFieldProps) => {
  const error = resolveFieldError(errors, name, composedName);
  const { fieldId } = fieldIds(name);

  return (
    <Box {...style}>
      <FieldShell name={name} label={label} required={required} error={error} hint={hint}>
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <TextArea
              size="2"
              id={fieldId}
              color={error ? "red" : undefined}
              {...fieldAria(name, error, hint)}
              {...field}
              {...fieldProps}
              value={value ?? field.value ?? ""}
            />
          )}
        />
      </FieldShell>
    </Box>
  );
};

export default TextAreaFieldComponent;
